const header = () => {
    handleScrollDesktop();
    menuMobile();

    // document.addEventListener(`click`, e => {
    //     const origin = e.target.closest(`a`);

    //     if (origin) {
    //         window.sessionStorage.setItem('isLoad', false)
    //         window.sessionStorage.setItem('isClick', true)
    //         console.log(`You clicked ${origin.href}`);
    //     }
    // });

    // document.addEventListener('readystatechange', (event) => {
    //     logoNotAnimation();
    // });

    // window.addEventListener('load', function () {
    //     if([null, 'true'].includes(window.sessionStorage.getItem('isLoad'))) {
    //         logoAnimation();
    //         window.sessionStorage.removeItem('isLoad')
    //     }
    // })

//     window.addEventListener("beforeunload", function(event) {
//         if(window.sessionStorage.getItem('isClick') !== 'true')
//             window.sessionStorage.removeItem('isLoad')
//         else window.sessionStorage.removeItem('isClick')
//    });
}

var scrollBefore = 0;

const handleScrollDesktop = () => {
    $(window).on('scroll', function () {
        if ($(window).width() < 992) return;

        const scrollTop = $(window).scrollTop();

        if (scrollTop > 80) {
            $("header.rio-header .navbar").addClass('smaller')
        //    $("header.rio-header .navbar .logo-img img").attr("src", "/upload/images/logo/logo.svg")
        }
        else {
            $("header.rio-header .navbar").removeClass('smaller')
        //    $("header.rio-header .navbar .logo-img img").attr("src", "/upload/images/logo/logo-left.svg")
        }

        // if (scrollTop > 80 && scrollTop > scrollBefore) {
        //     $('header.rio-header').fadeOut(500);
        // }
        // else {
        //     $('header.rio-header').fadeIn(500);
        // }
        scrollBefore = scrollTop;
    })
}

const menuMobile = () => {
    $(".rio-header .navbar-toggler").click(function () {
        $(".menu-mobile").fadeToggle()
        $(this).find(".navbar-toggler-icon").toggleClass("is-open")
    })
}

// const logoAnimation = () => {
//     let isMobile = window.innerWidth < 1024

//     anime({
//         targets: '.navbar-brand .logo-img-hn',
//         opacity: [0, 1],
//         duration: 600,
//         delay: 500,
//         easing: 'linear'
//     });

//     anime({
//         targets: '.navbar-brand .logo-img',
//         left: ["100%", "0%"],
//         opacity: [0, 1],
//         zIndex: {
//             value: 3,
//             delay: 1700
//         },
//         duration: 500,
//         delay: 1300,
//         easing: 'linear',
//     });

//     anime({
//         targets: '.navbar-brand .logo-img-hn',
//         easing: 'linear',
//         left: [isMobile ? "100%" : "174px", "0"],
//         opacity: {
//             value: [1, 0],
//             duration: 10,
//             delay: 3100
//         },
//         duration: 500,
//         delay: 2600
//     });
// }

const logoNotAnimation = () => {
    if(window.sessionStorage.getItem('isLoad') === 'false') {
        $('.logo-img-hn').css({
            left: 0,
            opacity: 0
        })
        $('.logo-img').css({
            left: 0,
            opacity: 1
        });
    }
    else {
        $('.logo-img-hn').css({
            opacity: 1
        })
    }
}

module.exports = header;
